(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("truncate-element", [], factory);
	else if(typeof exports === 'object')
		exports["truncate-element"] = factory();
	else
		root["truncate-element"] = factory();
})(window, function() {
return 